import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0df65f1f")

_pushScopeId("data-v-0df65f1f")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header card-p border-0" }
const _hoisted_7 = { class: "card-header-title mb-0 p-0 fs-5" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_9 = {
  key: 0,
  class: "fs-6 text-overflow text-overflow-z symbol"
}
const _hoisted_10 = {
  key: 1,
  class: "fs-6 text-overflow text-overflow-z symbol"
}
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_12 = { class: "fs-6 text-overflow text-overflow-z symbol" }
const _hoisted_13 = { style: {"white-space":"nowrap"} }
const _hoisted_14 = {
  style: {"white-space":"nowrap"},
  class: "d-block fs-6"
}
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = {
  key: 0,
  class: "card mb-5 card-p"
}
const _hoisted_19 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_20 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_21 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_22 = { class: "d-block fs-7 fw-300 mt-1" }
const _hoisted_23 = {
  key: 0,
  class: "d-block fs-7 fw-300 mt-2"
}
const _hoisted_24 = {
  key: 1,
  class: "card mb-5 card-p"
}
const _hoisted_25 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_26 = { class: "summary-list" }
const _hoisted_27 = { class: "card mb-5 card-p" }
const _hoisted_28 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_29 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "fs-4" }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = {
  key: 2,
  class: "card mb-5 card-p"
}
const _hoisted_36 = { class: "card-header-title mb-5 p-0 fs-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: false
    }, null, 8, ["loading"]),
    _createVNode(_component_InnerLoader, { loading: _ctx.sendMailLoader }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("header", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('message.QUOTATION_PRODUCT')), 1)
              ]),
              _createVNode(_component_Table, {
                columns: _ctx.columns,
                rows: _ctx.quotation.quotation_products,
                padding: 5
              }, {
                "cell-image": _withId(({ row: item }) => [
                  (item?.product?.media.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        (item?.product?.media[0].file_path)
                          ? (_openBlock(), _createBlock("span", _hoisted_9, [
                              _createVNode("img", {
                                src: item?.product?.media[0].file_path
                              }, null, 8, ["src"])
                            ]))
                          : (_openBlock(), _createBlock("span", _hoisted_10, [
                              _createVNode("img", { src: _ctx.defaultImage }, null, 8, ["src"])
                            ]))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("span", _hoisted_12, [
                          _createVNode("img", { src: _ctx.defaultImage }, null, 8, ["src"])
                        ])
                      ]))
                ]),
                "cell-price": _withId(({ row: item }) => [
                  _createVNode("span", _hoisted_13, _toDisplayString(item?.price_label_without_tax), 1)
                ]),
                "cell-description": _withId(({ row: item }) => [
                  _createTextVNode(_toDisplayString(JSON.parse(item?.product?.description?.name)[_ctx.system_locale]?.name), 1)
                ]),
                "cell-total": _withId(({ row: item }) => [
                  _createVNode("span", _hoisted_14, _toDisplayString(item?.total), 1)
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("header", _hoisted_19, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", {
                        class: "name-avatar",
                        style: 'background:' + _ctx.companyLogo(_ctx.customer?.user?.name)?.color
                      }, _toDisplayString(_ctx.companyLogo(_ctx.customer?.user?.name)?.name), 5),
                      _createVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.customer?.user?.name) + " ", 1),
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('message.QUOTATION_ID')) + " # " + _toDisplayString(_ctx.quotation?.id), 1),
                        (_ctx.customer?.parent)
                          ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('message.MANAGER_OF')) + " : " + _toDisplayString(_ctx.customer?.parent?.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.customer?.user?.roles == 'customer')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "view-all-details btn btn-custom fs-7",
                          to: {
                                    name: 'customer_detail',
                                    params: { uuid: _ctx.customer?.uuid }
                                },
                          onClick: _ctx.clearPageHistory
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.DETAILS')), 1)
                          ]),
                          _: 1
                        }, 8, ["to", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("header", _hoisted_25, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                  _createVNode("ul", _hoisted_26, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        content: _ctx.customer?.user?.email,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.email), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.phone_number), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_GROUP')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.customer_group?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.status == 1 ? _ctx.$t('message.ACTIVE') : _ctx.$t('message.INACTIVE')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_27, [
              _createVNode("header", _hoisted_28, _toDisplayString(_ctx.$t('message.QUOTATION_SUMMARY')), 1),
              (Object.values(_ctx.quotationTotals).length != 0)
                ? (_openBlock(), _createBlock("ul", _hoisted_29, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.SUB_TOTAL')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.quotationTotals?.sub_total?.value), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.shipping?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.quotationTotals?.shipping?.value), 1)
                    ]),
                    (_ctx.quotation.site.prices_with_tax == 0 && _ctx.quotationTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_30, [
                          _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.quotation?.discount_price_without_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.quotation.site.prices_with_tax == 1 && _ctx.quotationTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_31, [
                          _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.quotation?.discount_price_with_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.quotation.site.prices_with_tax == 0)
                      ? (_openBlock(), _createBlock("li", _hoisted_32, [
                          _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.quotationTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", _hoisted_33, [
                      _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.total?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.quotationTotals?.total?.value), 1)
                    ]),
                    (_ctx.quotation.site.prices_with_tax == 1)
                      ? (_openBlock(), _createBlock("li", _hoisted_34, [
                          _createVNode("strong", null, _toDisplayString(_ctx.quotationTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.quotationTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.quotation?.quotation_notes && _ctx.quotation?.quotation_notes?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_35, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quotation.quotation_notes, (quotationNotes, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("header", _hoisted_36, _toDisplayString(quotationNotes.note_type == 'note' ? 'Note' : 'PO Number'), 1),
                      _createVNode("div", {
                        innerHTML: quotationNotes?.note
                      }, null, 8, ["innerHTML"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
})